import * as bbIcon from '@/assets/images/payment/bank/bb.svg';
import * as caixaIcon from '@/assets/images/payment/bank/caixa.svg';
import * as santanderIcon from '@/assets/images/payment/bank/santander.svg';
import * as bradescoIcon from '@/assets/images/payment/bank/bradesco.svg';
import * as itauIcon from '@/assets/images/payment/bank/itau.svg';
import * as bs2Icon from '@/assets/images/payment/bank/bs2.svg';
import * as interIcon from '@/assets/images/payment/bank/inter.svg';
import * as originalIcon from '@/assets/images/payment/bank/original.svg';

export type BankCodes = '001' | '104' | '033' | '237' | '341' | '218' | '077' | '212';

export enum EBankCodes {
  bb = '001',
  caixa = '104',
  santander = '033',
  bradesco = '237',
  itau = '341',
  bs2 = '218',
  inter = '077',
  original = '212',
}

export const banks = [
  {
    code: EBankCodes.bb,
    bank: 'bb',
    icon: bbIcon,
  },
  {
    code: EBankCodes.caixa,
    bank: 'caixa',
    icon: caixaIcon,
  },
  {
    code: EBankCodes.santander,
    bank: 'santander',
    icon: santanderIcon,
  },
  {
    code: EBankCodes.bradesco,
    bank: 'bradesco',
    icon: bradescoIcon,
  },
  {
    code: EBankCodes.itau,
    bank: 'itau',
    icon: itauIcon,
  },
  {
    code: EBankCodes.bs2,
    bank: 'bs2',
    icon: bs2Icon,
  },
  {
    code: EBankCodes.inter,
    bank: 'inter',
    icon: interIcon,
  },
  {
    code: EBankCodes.original,
    bank: 'original',
    icon: originalIcon,
  },
];

export interface IBankAccount {
  bank_code: BankCodes;
  bank_branch: number|null;
  bank_account: number|null;
  bank_check_digit: number|null;
  cpf: number|null;

  third_party?: boolean;
  bank_third_party_registry?: null;
}

export class BankAccount {
  bank_code: BankCodes = '001';
  bank_branch: number|null = null;
  bank_account: number|null = null;
  bank_check_digit: number|null = null;
  cpf: number|null = null;

  third_party?: boolean = false;
  bank_third_party_registry?: null = null;

  constructor (bankAccount?: IBankAccount) {
    Object.assign(this, { ...bankAccount });
  }
}
